import Axios from "axios";
var PurchaseReportForUpperSupService = (function () {
    function PurchaseReportForUpperSupService() {
    }
    PurchaseReportForUpperSupService.prototype.getSupplierupperCategoryList = function (params) {
        return Axios.get("supplierclientapi/supplierupper/category_list", { params: params });
    };
    PurchaseReportForUpperSupService.prototype.getDetailReportList = function (params) {
        return Axios.get("supplierclientapi/purchase_report/list", { params: params });
    };
    PurchaseReportForUpperSupService.prototype.getSummaryList = function (params) {
        return Axios.get("supplierclientapi/purchase_summary_report/list", { params: params });
    };
    PurchaseReportForUpperSupService.createInstance = function () {
        PurchaseReportForUpperSupService.getInstance();
    };
    PurchaseReportForUpperSupService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return PurchaseReportForUpperSupService;
}());
export default PurchaseReportForUpperSupService;
